import React from "react";
import { Switch } from "@material-ui/core";
import styled from "styled-components";

const CustomSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  "&.MuiSwitch-root": {
    width: "70px !important",
    height: "48px !important",
  },

  width: 64,
  height: 34,
  padding: 0,
  position: "relative",

  "& .MuiSwitch-switchBase": {
    padding: 0,
    position: "absolute",
    top: "50%",
    left: 16,
    transform: "translateY(-50%)",
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translate(20px, -50%)",
      color: "var(--White)",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--teal-600)",
        opacity: 1,
        border: 0,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "var(--teal-400)",
      border: "3px solid var(--White)",
    },

    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "var(--surface-50)",
    },
  },
  "& .MuiSwitch-switchBase:hover + .MuiSwitch-track": {
    backgroundColor: "var(--surface-300)",
  },

  "& .MuiSwitch-thumb": {
    width: 20,
    height: 20,
    boxSizing: "border-box",
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: "var(--surface-200)",
    opacity: 1,
    width: "100%",
    height: "100%",
    transition: theme.transitions.create(["background-color"], {
      duration: 200,
    }),
  },
}));

export default CustomSwitch;
